/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import { PRODUCT_IDS } from "utils/constants";
import BankAccountItem from "./BankAccountItem";
import BankAccountListModal from "./BankAccountListModal";

const BankAccountList = ({ accounts }) => {
  const [showAll, setShowAll] = useState(false);
  if (!accounts?.length) {
    return null;
  }
  const hasMoreAccounts = accounts.length > 2;
  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  accounts = accounts.filter((account) =>
    account.appliedProducts.includes(PRODUCT_IDS.CREDIT_BOOST),
  );
  return (
    <div className="flex items-center space-x-1 overflow-x-auto">
      {accounts.slice(0, 2).map((a) => (
        <BankAccountItem account={a} key={a.uuid} />
      ))}
      {hasMoreAccounts && (
        <div
          style={{ height: 60, minWidth: 196 }}
          className="flex-1 py-3 border border-neutral-300 rounded cursor-pointer flex items-center justify-center underline"
          onClick={toggleShowAll}
        >
          <p className="font-bold">View all</p>
        </div>
      )}
      <BankAccountListModal
        isOpen={showAll}
        close={toggleShowAll}
        accounts={accounts}
      />
    </div>
  );
};

export default BankAccountList;
